<label class="ds-radio-button-wrapper">
    <input
        #input
        type="radio"
        [name]="name()"
        [value]="value()"
        [attr.id]="id() || null"
        [attr.checked]="checked() ? '' : null"
        [attr.disabled]="disabled() ? '' : null"
        (change)="onInputChange()"
        [attr.aria-label]="ariaLabel() || null"
        [attr.aria-labelledby]="ariaLabelledby() || null"
        [attr.aria-describedby]="ariaDescribedby() || null"
        class="ds-radio-button-input" />
    <div class="ds-radio-button-lever-wrapper">
        <span class="ds-radio-button-lever"></span>
    </div>
    <div class="ds-radio-button-text-wrapper">
        <span class="ds-radio-button-label-text">
            <ng-content />
        </span>
    </div>
</label>
